var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOverEars = function SvgOverEars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18 11.05V10a8 8 0 0 0-16 0v1.05q.243-.05.5-.05A2.5 2.5 0 0 1 5 13.5v3a2.5 2.5 0 0 1-5 0V10C0 4.477 4.477 0 10 0s10 4.477 10 10v6.5a2.5 2.5 0 0 1-5 0v-3a2.5 2.5 0 0 1 3-2.45m0 2.45a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0zm-16 0v3a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0",
    clipRule: "evenodd"
  })));
};
export default SvgOverEars;